const primaryMain = '#009CA6';
const primaryMainOpacity = 'rgba(0, 156, 166, 0.9)';
const secondaryMain = '#003A96';
const secondaryMainOpacity = 'rgba(0, 58, 150, 0.5)';
const secondaryLight = '#CF7F00';
const tertiaryMain = '#003079';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
